<template>
  <v-card v-if="inmueble">
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="closeDialog">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Editar Inmueble {{CA}} - {{inmueble.key}} - {{inmueble.inmueble.direccion}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="anexoVivienda">Anexo Vivienda</v-btn>
        <v-btn v-if="CA === 'VC'" dark flat @click="anexoDiversidad">Anexo Diversidad</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <!-- <v-layout row wrap>
      
    </v-layout> -->

    <v-layout row wrap>
      <!-- <v-flex xs12>
        <v-card color="red">
          <v-toolbar card>
            <v-icon>domain</v-icon>
            <v-toolbar-title class="font-weight-light">Datos Consolidados</v-toolbar-title>
          </v-toolbar>
        </v-card>
      </v-flex> -->

      <v-flex xs4>
        <InmuebleDatos 
          :inmueble="inmueble.inmueble"
          :refCatastral="catastroSelect"
          :idInmueble="inmueble.key"
          @listo="hecho = true"
          />
      </v-flex>

      <v-flex xs8>
        <InmueblePropietarios
          :usuarios="inmueble.usuarios"
          :refCatastral="catastroSelect"
          :idInmueble="inmueble.key"
        />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <UsuariosConsolidados :propietarios="datosPropietariosConsolidado" @verDatosCons="verDatosConsolidados" />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <!-- <v-flex xs12>
        <h2>Datos Burbuja</h2>
      </v-flex> -->
      <v-flex xs12>
        <InmuebleBurbuja
          :optionSimple="false"
          :dataBurbuja="dataBurbujaMostrar"
          :refCatastral="catastroSelect"
          :idInmueble="inmueble.key"
          :CA="CA"
          @consolida="consolidarDataBurbuja"
          @archivar="mostrarChange"
        />
      </v-flex>
    </v-layout>


    <v-snackbar v-model="hecho" :timeout="hechoTimeOut" top>
      Hecho !!
      <v-btn color="pink" flat @click="hecho = false">
        cerrar
      </v-btn>
    </v-snackbar>

    <v-dialog
      v-model="dialogSelecciona"
      width="500">
      <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
            Selecciona una opción
          </v-card-title>

          <v-card-text>
            <v-list>
              <v-list-tile @click="selectPropietarioConsolida('nuevo')">
                <v-list-tile-title>Agregar Nuevo Registro</v-list-tile-title>
              </v-list-tile>

              <v-list-tile @click="selectPropietarioConsolida(propietario)" v-for="(propietario, i) in datosPropietarios" :key="i">
                <v-list-tile-title>{{ propietario.data.private.nombre }} {{ propietario.data.private.apellido1 }} {{ propietario.data.private.apellido2 }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              @click="dialogSelecciona = false"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogConsolida"
      fullscreen hide-overlay transition="dialog-bottom-transition">
      <ConsolidaBurbuja 
        :userBurbuja="consolidaSelectedBurbuja"
        :userPropietario="consolidaSelectedPropietario"
        :CA="CA"
        @closeConsolida="dialogConsolida = false"
      />
    </v-dialog>

    <v-dialog
      v-if="mostrarConsolidados"
      v-model="dialogVerConsolidado"
      fullscreen hide-overlay transition="dialog-bottom-transition">
      <InmuebleBurbujaConsolidados
        @verDatosCons="verDatosConsolidados"
        :optionSimple="true"
        :dataBurbuja="mostrarConsolidados"
        :refCatastral="catastroSelect"
        :idInmueble="inmueble.key"
        :CA="CA"
      />
    </v-dialog>
    
    <!-- <v-layout
      justify-space-between
      pa-3>
      <v-flex d-flex>
        <v-card
          class="mx-auto"
          :loading="cardView.loading"
          :outlined="cardView.outlined"
          :elevation="cardView.elevation"
          :raised="cardView.raised"
          :width="800"
          :height="cardView.height"
          color="white"
        >
          <v-card-title :class="inmueble.isDataBurbuja === 'yes' ? 'green lighten-1' : 'amber lighten-1'">  
            Propietario / Inquilino Principal
          </v-card-title>
          <v-card-text>
            <v-layout
              justify-space-between
              pa-3>
              <v-flex d-flex>
                <p>Campos</p>
                <p>NOMBRE:</p>
              </v-flex>
              <v-flex d-flex>
                <p>Datos Consolidados</p>
                <p>{{ usuarios[0].nombre }}</p>
              </v-flex>
              <v-flex d-flex>
                <p>Datos Introducidos por el usuario</p>
                <p>NOMBRE POR USUARIO</p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

      </v-flex>
      <v-flex d-flex>
        Propietarios Secundarios
      </v-flex>
      <v-flex d-flex>
        Propietarios Terciarios
      </v-flex>
    </v-layout> -->
    
    <template v-if="debug">
      <pre>Active: {{ active }}</pre>
      <!-- <pre>user[0]: {{arrayUsers[0]}}</pre> -->
      <!-- <pre>Usuarios Inmueble</pre> -->
      <!-- <pre>{{datosPropietariosConsolidado}}</pre> -->

      <!-- <pre>{{ datosPropietarios }}</pre> -->

      <pre>Usuarios Consolidados:</pre>
      <pre>{{ mostrarConsolidados }}</pre>

      <pre>dataBurbujaMostrar:</pre>
      <pre>{{ dataBurbujaMostrar }}</pre>

      <!-- <pre>{{inmueble.usuarios.map(i => i.id)}}</pre> -->
      <!-- <pre>{{childrens.map(i => i.id)}}</pre> -->
      <!-- <pre>catastroSelect: {{catastroSelect}}</pre> -->
      <!-- <pre>Inmueble: {{inmueble}}</pre> -->
    </template>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import InmuebleDatos from "./parts/inmueble-datos"
import InmueblePropietarios from "./parts/inmueble-propietarios"
import InmuebleBurbuja from "./parts/inmueble-burbuja"
import InmuebleBurbujaConsolidados from "./parts/inmueble-burbuja-consolidados"
import ConsolidaBurbuja from "./parts/inmueble-burbuja-propietarios-consolida"
import UsuariosConsolidados from "./parts/usuarios-consolidados"
  export default {
    props: ["inmueble", "catastroSelect", "CA", "debug"],
    components: {
      InmuebleDatos,
      InmueblePropietarios,
      InmuebleBurbuja,
      ConsolidaBurbuja,
      UsuariosConsolidados,
      InmuebleBurbujaConsolidados
    },
    data () {
      return {
        dialog: false,
        dialogConsolida: false,
        dialogSelecciona: false,
        dialogVerConsolidado: false,
        dialogVerConsolidadoBorrar: false,
        consolidaSelectedBurbuja: null,
        consolidaSelectedPropietario: null,
        hecho: false,
        hechoTimeOut: 6000,
        cardView: {
          color: "purple lighten-5",
          flat: false,
          media: false,
          loading: true,
          actions: true,
          outlined: false,
          elevation: undefined,
          raised: false,
          width: 344,
          height: undefined,
        },
        users: [],
        active: []
      }
    },
    mounted() {
      // console.log(`CA = ${this.CA}`)
    },

    watch: {
      dialogConsolida(newValue) {
        if (!newValue) {
          this.consolidaSelectedBurbuja = null
          this.consolidaSelectedPropietario = null
        }
      },

      dialogAdminPropietariosEdit(newValue) {
        if (newValue) {
          this.dialog = true;
          this.cargaUsuarios();
        }
      },
      dialog(newValue, oldValue) {
        if (!newValue && oldValue) {
          this.setDialogAdminPropietariosEdit(false);
        }
      }
    },
    computed: {
      ...mapGetters(["dialogAdminPropietariosEdit"]),
      items () {
        return [
          {
            name: 'Propietarios',
            children: this.childrens
          }
        ]
      },
      childrens() {
        if (!this.inmueble || !this.inmueble.usuarios) {
          return [];
        }
        return this.inmueble.usuarios.map(u => {
          return {
            id: u.id,
            name: u.nombreApellidos
          }
        })
      },
      selected () {
        if (!this.active.length) return undefined

        const id = this.active[0]

        return this.inmueble.usuarios.find(user => user.id === id)
      },

      datosPropietarios() {
        if (!this.inmueble || !this.inmueble.usuarios) {
          return []
        }
        let result = []
        this.inmueble.usuarios.forEach(element => {
          const user = this.arrayUsers.filter(i => i.idx === element.id)[0]
          if (user) {
            result.push(user)
          }
        });
        return result
        // this.inmueble.usuarios
      },

      arrayUsers() {
        return this.$store.getters.getUsersArray;
      },

      dataBurbujaMostrar() {
        let result = [];
        if (this.inmueble && this.inmueble.dataBurbuja) {
          result = this.inmueble.dataBurbuja;
        }
        return result;
      },

      datosPropietariosConsolidado() {
        return this.datosPropietarios.filter(i => i.data.private.datosFormulario).map(p => {
          return {
            idx: p.idx,
            nombre: p.data.private.nombre,
            apellido1: p.data.private.apellido1,
            apellido2: p.data.private.apellido2
          }
        })
        // .map(p => p.data)
      },

      mostrarConsolidados() {
        if (!this.dialogVerConsolidado) {
          return null
        }
        return this.datosPropietarios.filter(i => i.idx === this.dialogVerConsolidado).map(p => p.data.private.datosFormulario)[0]
        /* return {
          propietarios: [{
            data: this.datosPropietarios.filter(i => i.idx === this.dialogVerConsolidado).map(p => p.data.private.datosFormulario)[0]
          }]
        } */
        // return this.dataBurbujaMostrar
      }
    },
    methods: {
      ...mapActions(["setDialogAdminPropietariosEdit", "changeMostrarBurbuja"]),

      verDatosConsolidados(id) {
        // console.log(`Ver los datos consolidados para: ${id}`)
        this.dialogVerConsolidado = id
      },

      anexoVivienda() {
        this.$emit("imprimirAnexo")
      },

      anexoDiversidad() {
        this.$emit("imprimirDiversidad")
      },

      selectPropietarioConsolida(propietario) {
        // console.log('Seleccionado el usuario: ', propietario)
        this.consolidaSelectedPropietario = propietario
        this.dialogSelecciona = false
        this.dialogConsolida = true
      },

      consolidarDataBurbuja(datos) {
        // console.log('Consolidar datos', datos)
        // console.log(`ref: ${this.catastroSelect}, id: ${this.inmueble.key}`)
        // console.log('propietarios: ', this.datosPropietarios)
        this.consolidaSelectedBurbuja = {
          ref: this.catastroSelect,
          idInmueble: this.inmueble.key,
          userBurbuja: datos
        }
        this.dialogSelecciona = true
      },

      mostrarChange(datos) {
        this.changeMostrarBurbuja(datos)
      },

      closeDialog() {
        this.$emit("closeDialog")
      },
      cargaUsuarios() {
        this.users = this.inmueble.usuarios;
      },
      async fetchUsers (item) {
        item.children.push(this.inmueble.usuarios)
        /* return fetch('https://jsonplaceholder.typicode.com/users')
          .then(res => res.json())
          .then(json => (item.children.push(...json)))
          .catch(err => console.warn(err)) */
      },
    }
  }
</script>
